const getters = {
  // 全局配置
  config: (state) => state.app.config,
  // 请求凭证
  token: (state) => state.user?.token || "",
  // 用户信息
  userInfo: (state) => state.user?.userInfo || {},
  // 权限列表
  permission: (state) => state.user?.permission || {},
  // 子账户请求凭证
  customerToken: (state) => state.customer?.token || "",
  // 子账户信息
  customerInfo: (state) => state.customer?.userInfo || {},
  // 子账户页面权限
  customerPagePermissions: (state) =>
    state.customer?.userInfo?.page_permissions || [],
};

export default getters;
